import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}`;

export const getWelcome = (guildId) => apiRequest(`${base(guildId)}/welcome`);
export const updateWelcome = (guildId, payload) =>
  apiRequest(`${base(guildId)}/welcome`, { method: "PATCH", body: payload });

export const getGoodbye = (guildId) => apiRequest(`${base(guildId)}/goodbye`);
export const updateGoodbye = (guildId, payload) =>
  apiRequest(`${base(guildId)}/goodbye`, { method: "PATCH", body: payload });
